var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { api_service } from '../../api/api_service';
import { api_urls } from '../../api/api_urls';
import { ASSET_FIELD } from './config/create_application_schema';
import { asText, SUCCESS_STATUS_CODE } from './service_helpers';
var FREE_TEXT_TYPE_MARKERS = ['miscellaneous', 'other'];
var toModelNames = function (models) {
    return (Array.isArray(models) ? models : [])
        .map(function (model) { return asText(model === null || model === void 0 ? void 0 : model.Name); })
        .filter(Boolean);
};
export var fetchEquipmentTypeOptions = function (programAspireOId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, rows, optionsByValue_1, error_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!programAspireOId) {
                    return [2, []];
                }
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4, api_service.get({
                        endPoint: api_urls.GET_ASSET_TYPE_INFO,
                        payLoad: { ProgramAspireOId: programAspireOId },
                        showLoader: false,
                    })];
            case 2:
                response = _b.sent();
                if (((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.statusCode) !== SUCCESS_STATUS_CODE) {
                    return [2, []];
                }
                rows = Array.isArray(response.data.data)
                    ? response.data.data
                    : [];
                optionsByValue_1 = new Map();
                rows.forEach(function (row) {
                    var value = asText(row.Code);
                    var description = asText(row.Description);
                    var type = asText(row.Type);
                    if (!value || optionsByValue_1.has(value)) {
                        return;
                    }
                    var rowModels = toModelNames(row.Models);
                    optionsByValue_1.set(value, {
                        label: description || type || value,
                        value: value,
                        description: description,
                        type: type,
                        isDescriptionFreeText: FREE_TEXT_TYPE_MARKERS.some(function (marker) {
                            return type.toLowerCase().includes(marker);
                        }),
                        manufacturers: (Array.isArray(row.Manufacturer) ? row.Manufacturer : [])
                            .map(function (manufacturer) { return ({
                            name: asText(manufacturer === null || manufacturer === void 0 ? void 0 : manufacturer.Name),
                            models: toModelNames(manufacturer === null || manufacturer === void 0 ? void 0 : manufacturer.Model).length
                                ? toModelNames(manufacturer === null || manufacturer === void 0 ? void 0 : manufacturer.Model)
                                : rowModels,
                        }); })
                            .filter(function (manufacturer) { return Boolean(manufacturer.name); }),
                    });
                });
                return [2, Array.from(optionsByValue_1.values())];
            case 3:
                error_1 = _b.sent();
                return [2, []];
            case 4: return [2];
        }
    });
}); };
var VIN_DECODE_URL = 'https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVINValuesBatch/';
var VIN_DECODE_TIMEOUT_MS = 30000;
var VIN_NOT_APPLICABLE = 'Not Applicable';
var DECODE_FAILED_MESSAGE = 'Details not found for the provided VIN. Please verify the VIN and try again.';
var NETWORK_FAILED_MESSAGE = 'Network error. Please check your connection and try again.';
var readDecodedField = function (result, fieldName) {
    var value = asText(result === null || result === void 0 ? void 0 : result[fieldName]) || asText(result === null || result === void 0 ? void 0 : result[fieldName.toLowerCase()]);
    return value === VIN_NOT_APPLICABLE ? '' : value;
};
export var decodeVin = function (vin) { return __awaiter(void 0, void 0, void 0, function () {
    var trimmedVin, body, response, result, manufacturer, model, year, values, error_2;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                trimmedVin = asText(vin);
                if (!trimmedVin) {
                    return [2, { values: {}, details: null, errorMessage: DECODE_FAILED_MESSAGE }];
                }
                _c.label = 1;
            case 1:
                _c.trys.push([1, 3, , 4]);
                body = new URLSearchParams();
                body.append('format', 'json');
                body.append('data', trimmedVin);
                return [4, axios.post(VIN_DECODE_URL, body.toString(), {
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        timeout: VIN_DECODE_TIMEOUT_MS,
                        withCredentials: false,
                    })];
            case 2:
                response = _c.sent();
                result = ((_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.Results) !== null && _b !== void 0 ? _b : [])[0];
                if (!result) {
                    return [2, { values: {}, details: null, errorMessage: DECODE_FAILED_MESSAGE }];
                }
                manufacturer = readDecodedField(result, 'Make');
                model = readDecodedField(result, 'Model');
                year = readDecodedField(result, 'ModelYear');
                if (!manufacturer && !model && !year) {
                    return [2, { values: {}, details: null, errorMessage: DECODE_FAILED_MESSAGE }];
                }
                values = {};
                if (manufacturer) {
                    values[ASSET_FIELD.Manufacturer] = manufacturer;
                }
                if (model) {
                    values[ASSET_FIELD.Model] = model;
                }
                if (year) {
                    values[ASSET_FIELD.Year] = year;
                }
                values[ASSET_FIELD.SerialNumber] = trimmedVin;
                return [2, {
                        values: values,
                        details: { manufacturer: manufacturer, model: model, year: year, vin: trimmedVin },
                        errorMessage: '',
                    }];
            case 3:
                error_2 = _c.sent();
                return [2, { values: {}, details: null, errorMessage: NETWORK_FAILED_MESSAGE }];
            case 4: return [2];
        }
    });
}); };
